export const LIST = 'LIST';
export const ACTIVED = 'ACTIVED';
export const IS_LOAD = 'IS_LOAD';
export const ACTIVE_NEW = 'ACTIVE_NEW';
export const PROVIDERS = 'PROVIDERS';
export const PRODUCTS = 'PRODUCTS';
export const SHOW_AMOUNT = 'SHOW_AMOUNT';
export const SHOW_NUMBER = 'SHOW_NUMBER';
export const SHOW_SUBMIT = 'SHOW_SUBMIT';
export const SHOW_LOAD = 'SHOW_LOAD';
export const RECHARGE = 'RECHARGE'
export const SHOW_ERROR = 'SHOW_ERROR';
export const ERRORS = 'ERRORS';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_CONFIRM = 'SHOW_CONFIRM';
export const SHOW_CANCEL = 'SHOW_CANCEL';
